import React, { useState, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { getURLByRouteName } from './utils/routes'
import { connect } from 'react-redux'
import { getProductList } from './services/products'
import { getGeneralInfo } from './services/general'
import { setProducts, setBrands } from './redux/actions/products'
import { getAccessToken } from './services/access'
import { setAccessToken } from './redux/actions/settings'
import { setRECAPTCHA } from './redux/actions/general'

import AboutUs from './pages/AboutUs'
import Contact from './pages/Contact'
import Home from './pages/Home'
import History from './pages/History'
import Legals from './pages/Legals'
import Loader from './baseComponents/Loader'
import Operations from './pages/ProductionAndOperations'
import SanferGlobal from './pages/SanferGlobal'
import PharmacoVigilance from './pages/PharmacoVigilance'
import Products from './pages/Products'
import SanferConecta from './pages/SanferConecta'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import Construction from './pages/Construction'
import Vademecum from './pages/Vademecum'

import './App.css'

const App = props => {
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    getAccessToken()
      .then(accessToken => {
        props.dispatch(setAccessToken(accessToken))

        getGeneralInfo()
          .then(res => {
            console.log('getGeneralInfo', res)
            props.dispatch(setRECAPTCHA(res.recaptcha_public_v2))
          })
          try {
            var k = accessToken.access_token;
            console.log('keikos555666');
          } catch (error) {
            debugger;
          }
        return getProductList(accessToken.access_token)
      })
      .then(res => {
        props.dispatch(setProducts(res.products))
        props.dispatch(setBrands(res.brands))
        setIsFetching(false)
      })

    /*
    
      .then(res => {
        props.dispatch(setProducts(res))
        return 
      })
      .then(accessToken => {
        
        setIsFetching(false)
      })
      .catch(err => console.log(err))
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (isFetching) return <Loader />


  return <div id='sanfer'>
    <Switch>
      <Route exact path={getURLByRouteName('home')} component={Home} />
      <Route exact path={getURLByRouteName('history')} component={History} />
      <Route exact path={getURLByRouteName('contact')} component={Contact} />
      <Route exact path={`${getURLByRouteName('legals')}/:id`} component={Legals} />
      <Route exact path={getURLByRouteName('aboutUs')} component={AboutUs} />
      <Route exact path={getURLByRouteName('global')} component={SanferGlobal} />
      <Route exact path={getURLByRouteName('operations')} component={Operations} />
      <Route exact path={getURLByRouteName('pharmacovigilance')} component={PharmacoVigilance} />
      <Route exact path={getURLByRouteName('healthcareProfessionals')} component={Vademecum} />
      <Route exact path={getURLByRouteName('sanferConecta')} component={SanferConecta} />
      <Route exact path={`${getURLByRouteName('products')}/:id`} component={Products} />
      <Route exact path={`${getURLByRouteName('post')}`} component={Blog} />
      <Route exact path={`${getURLByRouteName('blog')}/:id`} component={BlogPost} />
      <Route exact path={getURLByRouteName('construction')} component={Construction} />
      <Route component={Home} />
    </Switch>
  </div >
}

const mapStateToPros = state => ({
  products: state.products
})

export default connect(mapStateToPros)(App)